import { intervalToDuration } from 'date-fns';

class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.end = new Date(this.dataset.endDate);

    this.elements = {
      days: this.querySelector('[data-countdown-days-time]'),
      hours: this.querySelector('[data-countdown-hours-time]'),
      minutes: this.querySelector('[data-countdown-minutes-time]'),
      seconds: this.querySelector('[data-countdown-seconds-time]'),
    };

    this.setCountdown(this.getDuration());
    this.countdownIntervalId = setInterval(() => {
      this.setCountdown(this.getDuration());
    }, 1000);
  }

  disconnectedCallback() {
    if (this.countdownIntervalId) clearInterval(this.countdownIntervalId);
  }

  /**
   * Get the duration between the current date and the end date
   * @returns {Object} The duration values
   */
  getDuration() {
    const start = Date.now();
    const {
      years = 0,
      months = 0,
      weeks = 0,
      days = 0,
      hours = 0,
      minutes = 0,
      seconds = 0,
    } = intervalToDuration({ start, end: this.end });

    // Calculate the total number of days based on the years, months, weeks, and days
    const formattedDays = days + weeks * 7 + months * 30 + years * 365;

    return { days: formattedDays, hours, minutes, seconds };
  }

  /**
   * Set the countdown values in the DOM
   * @param {Object} countdown - The countdown values
   */
  setCountdown({ days, hours, minutes, seconds }) {
    // set all values to 0, if countdown is over
    if (seconds < 0) days = hours = minutes = seconds = 0;

    this.elements.days.textContent = String(days).padStart(2, '0');
    this.elements.hours.textContent = String(hours).padStart(2, '0');
    this.elements.minutes.textContent = String(minutes).padStart(2, '0');
    this.elements.seconds.textContent = String(seconds).padStart(2, '0');

    // stop counting on 0
    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0 && this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
    }
  }
}

customElements.define('countdown-bar', CountdownBar);
